export const getModulesFromAbbreviations = (pagesArray, bucketsLookup) => {
    let buckets = {};
    pagesArray.forEach((page) => {
        let pageKeys = [];
        if (page) {
            pageKeys = page.split('.');
            pageKeys.splice(0, 1);
        }
        //build a nested object out of the pageKeys
        if (pageKeys) {
            if (pageKeys && pageKeys.length == 2) {
                if (
                    pageKeys[1] != '*' &&
                    bucketsLookup[pageKeys[0]] &&
                    bucketsLookup[pageKeys[0]].pages &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]]
                ) {
                    if (!buckets[pageKeys[0]]) {
                        buckets[pageKeys[0]] = {
                            name: bucketsLookup[pageKeys[0]].name,
                            navKey: bucketsLookup[pageKeys[0]].navKey,
                            pages: {},
                        };
                    }
                    if (!buckets[pageKeys[0]].pages[pageKeys[1]]) {
                        buckets[pageKeys[0]].pages[pageKeys[1]] = {
                            name: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].name,
                            navKey: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].navKey,
                            pages: {},
                        };
                    }

                    buckets[pageKeys[0]].pages[pageKeys[1]].route = bucketsLookup[pageKeys[0]].pages[pageKeys[1]].route;
                    (buckets[pageKeys[0]].pages[pageKeys[1]].pinned = true),
                        (buckets[pageKeys[0]].pages[pageKeys[1]].pinPath = page);
                } else if (pageKeys[1] == '*' && bucketsLookup[pageKeys[0]] && bucketsLookup[pageKeys[0]].pages) {
                    if (!buckets[pageKeys[0]]) {
                        buckets[pageKeys[0]] = {
                            name: bucketsLookup[pageKeys[0]].name,
                            navKey: bucketsLookup[pageKeys[0]].navKey,
                            pages: {},
                        };
                    }
                    buckets[pageKeys[0]].pinned = true;
                    buckets[pageKeys[0]].pinPath = page;
                }
            } else if (pageKeys && pageKeys.length == 3) {
                if (
                    pageKeys[2] != '*' &&
                    bucketsLookup[pageKeys[0]] &&
                    bucketsLookup[pageKeys[0]].pages &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]] &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]]
                ) {
                    if (!buckets[pageKeys[0]]) {
                        buckets[pageKeys[0]] = {
                            name: bucketsLookup[pageKeys[0]].name,
                            navKey: bucketsLookup[pageKeys[0]].navKey,
                            pages: {},
                        };
                    }
                    if (!buckets[pageKeys[0]].pages[pageKeys[1]]) {
                        buckets[pageKeys[0]].pages[pageKeys[1]] = {
                            name: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].name,
                            navKey: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].navKey,
                            pages: {},
                        };
                    }

                    if (!buckets[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]]) {
                        buckets[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]] = {
                            name: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].name,
                            navKey: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].navKey,
                            pages: {},
                        };
                    }

                    (buckets[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].pinned = true),
                        (buckets[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].pinPath = page),
                        (buckets[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].route =
                            bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages[pageKeys[2]].route);
                } else if (
                    pageKeys[2] == '*' &&
                    bucketsLookup[pageKeys[0]] &&
                    bucketsLookup[pageKeys[0]].pages &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]] &&
                    bucketsLookup[pageKeys[0]].pages[pageKeys[1]].pages
                ) {
                    if (!buckets[pageKeys[0]]) {
                        buckets[pageKeys[0]] = {
                            name: bucketsLookup[pageKeys[0]].name,
                            navKey: bucketsLookup[pageKeys[0]].navKey,
                            pages: {},
                        };
                    }
                    if (!buckets[pageKeys[0]]['pages'][pageKeys[1]]) {
                        buckets[pageKeys[0]]['pages'][pageKeys[1]] = {
                            name: bucketsLookup[pageKeys[0]]['pages'][pageKeys[1]].name,
                            navKey: bucketsLookup[pageKeys[0]]['pages'][pageKeys[1]].navKey,
                            pages: bucketsLookup[pageKeys[0]]['pages'][pageKeys[1]].pages,
                        };
                    }

                    buckets[pageKeys[0]].pages[pageKeys[1]].pinned = true;
                    buckets[pageKeys[0]].pages[pageKeys[1]].pinPath = page;
                }
            }
        }
    });

    return buckets;
};
